import { render, staticRenderFns } from "./TenantDetailsMicrosoftPartner.vue?vue&type=template&id=3e58d9cc"
import script from "./TenantDetailsMicrosoftPartner.vue.ts?vue&type=script&lang=ts&external"
export * from "./TenantDetailsMicrosoftPartner.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports